{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Вы превысили лимит диалогов. План \"Хакер\" позволяет только 500 диалогов.",
      "INBOXES": "Вы превысили лимит входящих сообщений. План \"Хакер\" поддерживает только live-чат на сайте. Дополнительные почтовые ящики, такие как электронная почта, WhatsApp и т.д. требуют платного плана.",
      "AGENTS": "Вы превысили лимит агентов. Ваш план разрешает только {allowedAgents} агентов.",
      "NON_ADMIN": "Пожалуйста, свяжитесь с вашим администратором, чтобы обновить план и продолжить использовать все функции."
    },
    "TITLE": "Настройки аккаунта",
    "SUBMIT": "Изменить настройки",
    "BACK": "Назад",
    "DISMISS": "Отклонить",
    "UPDATE": {
      "ERROR": "Не удалось обновить настройки, попробуйте снова!",
      "SUCCESS": "Настройки аккаунта обновлены"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Удалить ваш аккаунт",
      "NOTE": "После удаления учетной записи, все данные будут удалены.",
      "BUTTON_TEXT": "Удалить ваш аккаунт",
      "CONFIRM": {
        "TITLE": "Удалить аккаунт",
        "MESSAGE": "Удаление учетной записи необратимо. Введите имя вашей учетной записи ниже, чтобы подтвердить ее удаление.",
        "BUTTON_TEXT": "Удалить",
        "DISMISS": "Отменить",
        "PLACE_HOLDER": "Пожалуйста, введите {accountName} для подтверждения"
      },
      "SUCCESS": "Учетная запись отмечена как удаленная",
      "FAILURE": "Не удалось удалить аккаунт, попробуйте еще раз!",
      "SCHEDULED_DELETION": {
        "TITLE": "Учетная запись запланирована к удалению",
        "MESSAGE_MANUAL": "Эта учетная запись запланирована к удалению {deletionDate}. Это было запрошено администратором. Вы можете отменить удаление до этой даты.",
        "MESSAGE_INACTIVITY": "Эта учетная запись запланирована к удалению {deletionDate} из-за отсутствия активности. Вы можете отменить удаление до этой даты.",
        "CLEAR_BUTTON": "Отменить запланированное удаление"
      }
    },
    "FORM": {
      "ERROR": "Пожалуйста исправьте ошибки",
      "GENERAL_SECTION": {
        "TITLE": "Общие настройки",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID аккаунта",
        "NOTE": "Этот ID требуется для построения интеграции, основанной на API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Автоматически завершать диалоги",
        "NOTE": "Эта опция позволит вам завершать диалоги после определенного периода бездействия.",
        "DURATION": {
          "LABEL": "Время бездействия",
          "HELP": "Время бездействия, после которого диалог будет завершен",
          "PLACEHOLDER": "30",
          "ERROR": "Время автозавершения должно быть между 10 минутами и 999 днями",
          "API": {
            "SUCCESS": "Настройки автозавершения успешно обновлены",
            "ERROR": "Не удалось обновить настройки автозавершения"
          }
        },
        "MESSAGE": {
          "LABEL": "Сообщение об автозавершении диалога",
          "PLACEHOLDER": "Диалог помечен завершенным автоматически из-за бездействия в течение 15 дней",
          "HELP": "Сообщение будет отправлено после автозавершения диалога"
        },
        "PREFERENCES": "Настройки",
        "LABEL": {
          "LABEL": "Добавить метку после автозавершения",
          "PLACEHOLDER": "Выбрать метку"
        },
        "IGNORE_WAITING": {
          "LABEL": "Пропустить диалоги ожидающие ответа агента"
        },
        "UPDATE_BUTTON": "Сохранить"
      },
      "NAME": {
        "LABEL": "Имя аккаунта",
        "PLACEHOLDER": "Имя вашего аккаунта",
        "ERROR": "Пожалуйста, введите корректное имя аккаунта"
      },
      "LANGUAGE": {
        "LABEL": "Язык сайта",
        "PLACEHOLDER": "Имя вашего аккаунта",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Домен входящей почты",
        "PLACEHOLDER": "Домен, на который вы принимаете письма",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email поддержки",
        "PLACEHOLDER": "Email службы поддержки вашей компании",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Исключить неотвеченные диалоги",
        "HELP": "Если включено, система пропускает разрешение диалогов, которые все еще ждут ответа агента."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Расшифровать аудио сообщения",
        "NOTE": "Автоматически расшифровывать аудио сообщения в диалогах. Генерировать текстовые субтитры при отправке или получении звукового сообщения и отображать их вместе с сообщением.",
        "API": {
          "SUCCESS": "Настройки расшифровки аудио сообщений успешно обновлены",
          "ERROR": "Не удалось обновить настройки расшифровки аудио сообщений"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Длительность бездействия для автозавершения",
        "HELP": "Длительность бездействия для автозавершения, если не было активности",
        "PLACEHOLDER": "30",
        "ERROR": "Время автозавершения должно быть между 10 минутами и 999 днями",
        "API": {
          "SUCCESS": "Настройки автозавершения сохранены",
          "ERROR": "Не удалось обновить настройки автозавершения"
        },
        "UPDATE_BUTTON": "Обновить",
        "MESSAGE_LABEL": "Сообщение при автозавершении",
        "MESSAGE_PLACEHOLDER": "Диалог помечен завершенным автоматически из-за бездействия в течение 15 дней",
        "MESSAGE_HELP": "Это сообщение отправляется клиенту, когда разговор автоматически решен системой из-за бездействия."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Для вашего аккаунта включено продолжение диалогов по электронной почте.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Теперь вы можете получать письма на свой домен."
      }
    },
    "UPDATE_CHATWOOT": "Доступно обновление {latestChatwootVersion} для Chatwoot. Пожалуйста, обновите свою версию.",
    "LEARN_MORE": "Узнайте больше",
    "PAYMENT_PENDING": "Ваш платеж в ожидании. Пожалуйста, обновите платежную информацию, чтобы продолжить использовать Chatwoot",
    "UPGRADE": "Обновитесь, чтобы продолжить использовать Chatwoot",
    "LIMITS_UPGRADE": "Превышен лимит использования вашего тарифного плана, пожалуйста, обновите тарифный план, чтобы продолжить использовать Chatwoot",
    "OPEN_BILLING": "Открыть платеж"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Нажмите Enter для выбора",
      "ENTER_TO_REMOVE": "Нажмите Enter для удаления",
      "NO_OPTIONS": "Список пуст",
      "SELECT_ONE": "Выберите один",
      "SELECT": "Выбрать"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Уведомления",
    "MARK_ALL_DONE": "Отметить все прочитанными",
    "DELETE_TITLE": "удалено",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Непрочитанные уведомления",
      "ALL_NOTIFICATIONS": "Показать все уведомления",
      "LOADING_UNREAD_MESSAGE": "Загрузка непрочитанных уведомлений...",
      "EMPTY_MESSAGE": "У вас нет непрочитанных уведомлений"
    },
    "LIST": {
      "LOADING_MESSAGE": "Загрузка уведомлений...",
      "404": "Уведомления отсутствуют",
      "TABLE_HEADER": [
        "Имя",
        "Номер телефона",
        "Диалоги",
        "Последний Контакт"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Новая беседа",
      "conversation_assignment": "Беседа назначена",
      "assigned_conversation_new_message": "Новое сообщение",
      "participating_conversation_new_message": "Новое сообщение",
      "conversation_mention": "Упоминание",
      "sla_missed_first_response": "Пропущено SLA",
      "sla_missed_next_response": "Пропущено SLA",
      "sla_missed_resolution": "Пропущено SLA"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Оффлайн",
      "RECONNECTING": "Повторное подключение:",
      "RECONNECT_SUCCESS": "Повторное подключение успешно"
    },
    "BUTTON": {
      "REFRESH": "Обновить"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Искать или перейти к",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Главное",
      "REPORTS": "Отчёты",
      "CONVERSATION": "Диалоги",
      "BULK_ACTIONS": "Массовые действия",
      "CHANGE_ASSIGNEE": "Изменить Назначенного",
      "CHANGE_PRIORITY": "Изменить приоритет",
      "CHANGE_TEAM": "Изменить команду",
      "SNOOZE_CONVERSATION": "Включить звук диалога",
      "ADD_LABEL": "Добавить метку в диалог",
      "REMOVE_LABEL": "Удалить метку из диалога",
      "SETTINGS": "Настройки",
      "AI_ASSIST": "Помощь ИИ",
      "APPEARANCE": "Образец",
      "SNOOZE_NOTIFICATION": "Отложить уведомление"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти к панели разговоров",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти к панели контактов",
      "GO_TO_REPORTS_OVERVIEW": "Перейти к обзору отчетов",
      "GO_TO_CONVERSATION_REPORTS": "Перейти к отчетам по диалогам",
      "GO_TO_AGENT_REPORTS": "Перейти к отчетам по сотрудникам",
      "GO_TO_LABEL_REPORTS": "Перейти к отчетам по меткам",
      "GO_TO_INBOX_REPORTS": "Перейти к отчётам по «Входящим»",
      "GO_TO_TEAM_REPORTS": "Перейти к отчетам по командам",
      "GO_TO_SETTINGS_AGENTS": "Перейти к настройкам сотрудников",
      "GO_TO_SETTINGS_TEAMS": "Перейти к настройкам команд",
      "GO_TO_SETTINGS_INBOXES": "Перейти к настройкам «Входящих»",
      "GO_TO_SETTINGS_LABELS": "Перейти к настройкам меток",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Перейти к настройкам шаблонных ответов",
      "GO_TO_SETTINGS_APPLICATIONS": "Перейти в настройки приложения",
      "GO_TO_SETTINGS_ACCOUNT": "Перейти в настройки учетной записи",
      "GO_TO_SETTINGS_PROFILE": "Перейти в настройки профиля",
      "GO_TO_NOTIFICATIONS": "Перейти к уведомлениям",
      "ADD_LABELS_TO_CONVERSATION": "Добавить метку в диалог",
      "ASSIGN_AN_AGENT": "Назначить сотрудника",
      "AI_ASSIST": "Помощь ИИ",
      "ASSIGN_PRIORITY": "Назначить приоритет",
      "ASSIGN_A_TEAM": "Назначить команду",
      "MUTE_CONVERSATION": "Заглушить диалог",
      "UNMUTE_CONVERSATION": "Включить диалог",
      "REMOVE_LABEL_FROM_CONVERSATION": "Удалить метку из диалога",
      "REOPEN_CONVERSATION": "Переоткрыть разговор",
      "RESOLVE_CONVERSATION": "Решить разговор",
      "SEND_TRANSCRIPT": "Отправить историю переписки на email",
      "SNOOZE_CONVERSATION": "Включить звук диалога",
      "UNTIL_NEXT_REPLY": "До следующего ответа",
      "UNTIL_NEXT_WEEK": "До следующей недели",
      "UNTIL_TOMORROW": "До завтра",
      "UNTIL_NEXT_MONTH": "До следующего месяца",
      "AN_HOUR_FROM_NOW": "Еще через час",
      "UNTIL_CUSTOM_TIME": "Пользовательский...",
      "CHANGE_APPEARANCE": "Изменить внешний вид",
      "LIGHT_MODE": "Светлая",
      "DARK_MODE": "Тёмная",
      "SYSTEM_MODE": "Система",
      "SNOOZE_NOTIFICATION": "Отложить уведомление"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Загрузка приложения панели управления..."
  },
  "COMMON": {
    "OR": "Или",
    "CLICK_HERE": "нажмите здесь"
  }
}
